import { loadModules } from "esri-loader";
export default class HighFeauture2D {
  private static intances: Map<string, any>;
  public view: any;
  private graphics: any;
  private customLayer: any;
  private overlayer: any;

  private constructor(view: __esri.MapView) {
    // Geometrical transformations that must be recomputed
    // from scratch at every frame.
    this.view = view;
  }
  public static getInstance(view: __esri.MapView) {
    let id = view.container.id;
    if (!HighFeauture2D.intances) {
      HighFeauture2D.intances = new Map();
    }
    let intance = HighFeauture2D.intances.get(id);
    if (!intance) {
      intance = new HighFeauture2D(view);
      HighFeauture2D.intances.set(id, intance);
    }
    return intance;
  }
  public static destroy() {
    (HighFeauture2D.intances as any) = null;
  }
  private removeGraphic(id: number) {
    if (this.overlayer && this.overlayer.graphics.length > 0) {
      for (let i = 0; i < this.overlayer.graphics.length; i++) {
        let g = this.overlayer.graphics.getItemAt(i);
        if (g && g.attributes.jumpId == id) {
          // console.log("remove", id);
          this.overlayer.remove(g);
          break;
        }
      }
    }
  }
  private clear() {
    if (this.overlayer) {
      this.overlayer.removeAll();
      this.view.map.remove(this.overlayer);
    }
    if (this.graphics) {
      this.graphics.forEach((graphic: any) => {
        graphic.visible = true;
      }, this);
    }
    if (this.customLayer) {
      this.view.map.remove(this.customLayer);
    }
  }
  public async startup(graphics: any[]) {
    this.clear();
    this.graphics = graphics;
    let _that = this;
    await loadModules([
      "esri/views/2d/layers/BaseLayerViewGL2D",
      "esri/layers/GraphicsLayer",
      "esri/Graphic",
      "esri/core/watchUtils",
    ]).then(([BaseLayerViewGL2D, GraphicsLayer, Graphic, watchUtils]) => {
      _that.overlayer = new GraphicsLayer();
      _that.view.map.add(_that.overlayer);
      let CustomLayerView2D = BaseLayerViewGL2D.createSubclass({
        aPosition: 0,
        aOffset: 1,
        isUp: true,
        upDis: 25, //跳动的幅度
        currentDis: 0,
        upCount: 1, //跳动的次数
        graphicsClone: null,
        constructor: function () {
          this.graphicsClone = [];
        },
        attach: function () {
          graphics.forEach((graphic: any, index: number) => {
            graphic.visible = false;
            this.upDis = Math.min(Math.round(graphic.symbol.height / 1.2), 45);
            var g = new Graphic({
              geometry: graphic.geometry,
              symbol: graphic.symbol.clone(),
              attributes: { jumpId: index, ...graphic.attributes },
            });
            this.graphicsClone.push(g);
          }, this);
        },
        detach: function () {
          this.upDis == 0;
          _that.view.map.remove(_that.customLayer);
        },
        // Called every time a frame is rendered.
        render: function (context: any) {
          if (this.upDis == 0) {
            if (_that.overlayer) {
              _that.overlayer.removeAll();
              _that.view.map.remove(_that.overlayer);
            }
            graphics.forEach((graphic: any) => {
              graphic.visible = true;
            }, this);
            _that.view.map.remove(_that.customLayer);
            return;
          }
          ////@notice
          /// 参照示例 https://developers.arcgis.com/javascript/latest/sample-code/sandbox/?sample=custom-gl-visuals
          this.graphicsClone.forEach((graphic: any, index: number) => {
            if (this.isUp) {
              if (
                graphic.symbol.yoffset == undefined ||
                Number.isNaN(graphic.symbol.yoffset)
              ) {
                graphic.symbol.yoffset = 0;
              }
              graphic.symbol.yoffset++;
              if (this.currentDis >= this.upDis) {
                //切换弹跳方向
                this.currentDis = 0;
                this.isUp = false;
              }
            } else {
              graphic.symbol.yoffset--;
              if (this.currentDis >= this.upDis) {
                //切换弹跳方向
                this.currentDis = 0;
                this.isUp = true;
                this.upCount += 0.4;
                this.upDis = Math.round(this.upDis / this.upCount);
              }
            }
            // this.currentDis += 4;
            var gra = new Graphic({
              geometry: graphic.geometry,
              symbol: graphic.symbol.clone(),
              attributes: { jumpId: index, ...graphic.attributes },
            });
            _that.removeGraphic(index);
            _that.overlayer.add(gra);
          }, this);
          this.currentDis += 4;
          if (this.upDis > 0) {
            this.requestRender();
          }
        },
      });
      let CustomLayer = GraphicsLayer.createSubclass({
        createLayerView: function (view: any) {
          // We only support MapView, so we only need to return a
          // custom layer view for the `2d` case.
          if (view.type === "2d") {
            return new CustomLayerView2D({
              view: view,
              layer: this,
            });
          }
        },
      });
      _that.customLayer = new CustomLayer();
      _that.view.map.add(_that.customLayer);
    });
  }
}
